import MaterialIcon from "react-google-material-icons";
import { useTranslation } from "react-i18next";

const splitCredential = (text) => {
  const idx = text.indexOf(":");
  if (idx === -1) return { heading: text, body: "" };
  return { heading: text.slice(0, idx).trim(), body: text.slice(idx + 1).trim() };
};

// Resolve a localised string object { de, en, pl } using the active i18next language
const useLocale = () => {
  const { i18n } = useTranslation();
  return (obj) => obj[i18n.language] ?? obj["de"] ?? Object.values(obj)[0];
};

export const BenefitModal = ({ data, onClose }) => {
  const loc = useLocale();
  if (!data) return null;

  const bullets  = loc(data.bullets);
  const table    = data.table;

  return (
    <div className="benefit-modal" onClick={onClose}>
      <div className="benefit-modal-panel" onClick={e => e.stopPropagation()}>

        <button className="gallery-modal-close-btn" onClick={onClose}>
          <MaterialIcon icon="close" size={22}/>
        </button>

        {/* ── Header ── */}
        <div className="benefit-modal-header">
          <div className="benefit-modal-header-left">
            <span className="benefit-modal-header-icon">
              <MaterialIcon icon={data.icon} size={40}/>
            </span>
            <div className="benefit-modal-header-titles">
              <span className="benefit-modal-chapter">{loc(data.chapter)}</span>
              <span className="benefit-modal-subtitle">{loc(data.subtitle)}</span>
            </div>
          </div>
          <div className="benefit-modal-kpi-badge">
            <span className="benefit-modal-kpi-value">{data.value}</span>
            <span className="benefit-modal-kpi-label">{loc(data.label)}</span>
          </div>
        </div>
        <div className="benefit-modal-title-bar"></div>

        {/* ── Highlight metrics ── */}
        <div className="benefit-modal-highlights">
          {data.highlights.map((h, i) => (
            <div key={i} className="benefit-modal-highlight-card">
              <span className="benefit-modal-highlight-value">{h.value}</span>
              <span className="benefit-modal-highlight-label">{loc(h.label)}</span>
              <span className="benefit-modal-highlight-source">{loc(h.source)}</span>
            </div>
          ))}
        </div>

        {/* ── Bullet points ── */}
        <ul className="benefit-modal-bullets">
          {bullets.map((b, i) => {
            const { heading, body } = splitCredential(b);
            return (
              <li key={i} className="benefit-modal-bullet-item">
                <span className="benefit-modal-bullet-icon">
                  <MaterialIcon icon="arrow_forward" size={15}/>
                </span>
                <span className="benefit-modal-bullet-content">
                  <span className="benefit-modal-bullet-heading">{heading}</span>
                  {body && <span className="benefit-modal-bullet-body">{body}</span>}
                </span>
              </li>
            );
          })}
        </ul>

        {/* ── Data table ── */}
        {table && (
          <div className="benefit-modal-table-wrap">
            {table.caption && (
              <p className="benefit-modal-table-caption">{loc(table.caption)}</p>
            )}
            <table className="benefit-modal-table">
              <thead>
                <tr>
                  {loc(table.headers).map((h, i) => <th key={i}>{h}</th>)}
                </tr>
              </thead>
              <tbody>
                {loc(table.rows).map((row, i) => (
                  <tr key={i}>
                    {row.map((cell, j) => <td key={j}>{cell}</td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* ── Source note ── */}
        <p className="benefit-modal-source">
          Quelle: Kallideus Whitepaper „Pragmatische Digitalisierung", 2026
        </p>

      </div>
    </div>
  );
};
